"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./footer.component"));
__export(require("./pager.component"));
__export(require("./footer.directive"));
__export(require("./footer-template.directive"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/dnata-cerf-front-end/releases/20200326161233/~/@swimlane/ngx-datatable/release/components/footer/index.js
// module id = RP9C
// module chunks = 4